import SocialLink from './SocialLink'

export default SocialLink
